import AntIcon from "@/components/icons/AntIcon";
import { formatLocaleDate } from "@/utils/formatUtils";
import { Button, DescriptionsProps, Space } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ComponentWithPermission from "../../../auth/components/ComponentWithPermission";
import { DepositContract, InsuranceContract, InvestmentContract } from "../../types";
import { contractPermissionsByContractType } from "../../utils";
import { ContractCancellationEffectiveEndDateModalForm } from "../ContractCancellationEffectiveEndDateModalForm";

type ContractWithEffectiveEndDate = DepositContract | InsuranceContract | InvestmentContract;

interface EffectiveEndDateDescriptionLabelProps {
  contract: ContractWithEffectiveEndDate;
}

const EffectiveEndDateDescriptionLabel = ({ contract }: EffectiveEndDateDescriptionLabelProps) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Space size="small">
        <span>{t("contract.attrs.effectiveEndDate")}</span>

        <ComponentWithPermission permissions={[contractPermissionsByContractType[contract.type].limitedUpdate]}>
          <Button
            icon={<AntIcon type="edit" />}
            size="small"
            variant="text"
            color="primary"
            onClick={() => setIsModalOpen(true)}
          />
        </ComponentWithPermission>
      </Space>

      <ContractCancellationEffectiveEndDateModalForm
        contract={contract}
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};

export const createEffectiveEndDateDescriptionItem = (
  contract: ContractWithEffectiveEndDate,
): NonNullable<DescriptionsProps["items"]>[number] => ({
  label: <EffectiveEndDateDescriptionLabel contract={contract} />,
  children: contract.effectiveEndDate ? formatLocaleDate(contract.effectiveEndDate) : undefined,
});
